package com.essntl.core.waypoint.data.response

import com.essntl.core.waypoint.domain.models.WaypointLogs
import kotlinx.serialization.Serializable

@Serializable
data class WaypointLogsData(
    val id: String,
    val code: String,
    val message: String,
    val createdAt: String,
) {
    fun toModel() = WaypointLogs(
        id = id,
        status =
        if (code.contains("ERROR")) WaypointLogs.Status.ERROR
        else
            when (code) {
                "EMAIL_MESSAGE_CREATED" -> WaypointLogs.Status.CREATED
                "EMAIL_MESSAGE_SENT_SES_EVENT" -> WaypointLogs.Status.SENT
                "EMAIL_MESSAGE_DELIVERED_SES_EVENT" -> WaypointLogs.Status.DELIVERED
                "EMAIL_MESSAGE_OPEN_SES_EVENT" -> WaypointLogs.Status.OPENED
                else -> null
            },
        message = message,
        createdAt = createdAt,
    )
}
